// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_89-3";
export var contentContainer = "_89-0";
export var editorContainer = "_89-1";
export var quillInputForm = "_89-2";
export var zoneDivider = "_89-4";